import ScreenLayout from 'components/common/ScreenLayout';
import React, {useEffect, useState} from 'react';
import styled, {css} from 'styled-components';
import {colors} from 'styles/colors';
import {minmax} from 'utils/minmax';
import DefaultText from 'components/common/DefaultText';
import {useRecoilValue} from 'recoil';
import {userInfoState} from 'utils/Atoms';
import {
  registerSalesManager,
  searchSalesProfileDetail,
  updateSalesManagerProfile,
} from 'function/api';
import DefaultButton from 'components/common/DefaultButton';
import CommonModal from 'components/common/CommonModal';
import ContainerHeader from 'components/common/ContainerHeader';
import PhoneNumberInput from 'components/common/PhoneNumberInput';
import {countryArray} from 'data/country';
import LabelInput from 'components/common/LabelInput';
import {getDevice} from 'utils/getDevice';
import moment from 'moment';
import {useLocation, useNavigate} from 'react-router-dom';
import {formatPhoneNumber} from 'utils/fomatPhoneNumber';

export default function SalesManagerEdit() {
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({});
  const device = getDevice();
  const [modal, setModal] = useState('');
  const userInfo = useRecoilValue(userInfoState);

  const [selectCountry, setSelectCountry] = useState(countryArray[0]);
  const [info, setInfo] = useState<any>();
  // 비밀번호 보이기
  const [isVisiblePassword, setVisiblePassword] = useState<boolean>(false);

  const navigate = useNavigate();
  const location = useLocation();
  const uuid = location.state;

  useEffect(() => {
    if (userInfo) {
      searchSalesProfileDetail({
        userInfo,
        setIsLoading,
        setErrorModal,
        salesManagerUUID: uuid,
      }).then(result => {
        setInfo(result?.userProfile);
      });
    }
  }, [userInfo, uuid]);

  const modalData: {[key: string]: any} = {
    complete: {
      title: '계정 등록 완료!',
      detail: '세일즈 매니저 계정 생성이 완료되었습니다.',
      firstButtonText: 'confirm',
      firstButtonStyle: {
        backgroundColor: colors.primary2,
      },
      firstButtonClick: () => {
        setModal('');
        window.location.reload();
      },
    },
  };

  const editProfile = async () => {
    const result = await updateSalesManagerProfile({
      userInfo,
      setErrorModal,
      setIsLoading,
      name: info?.name,
      email: info?.email,
      userUUID: info?.owner?.uuid,
      salesManagerUUID: uuid,
    });
    if (result) {
      navigate('-1');
    }
  };

  return (
    <ScreenLayout isLoading={isLoading} errorModal={errorModal}>
      <Container>
        <ContainerHeader mainTitle="파트너 등록" />
        <Inner $device={device}>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            <DefaultText
              text="세일즈 파트너 정보 수정하기"
              textStyle={{
                fontSize: minmax(25),
                fontWeight: 'bold',
                borderBottom: `3px solid ${colors.primary}`,
                width: 'fit-content',
                textWrap: 'nowrap',
                height: 'fit-content',
              }}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'right',
                width: '100%',
              }}>
              <DefaultButton
                text={'save'}
                buttonStyle={{
                  backgroundColor: colors.primary2,
                  width: 'fit-content',
                  padding: minmax(30),
                }}
                textStyle={{color: colors.white}}
                // onClick={() => navigate('/SalesManagerEdit')}
              />
            </div>
          </div>
          <LabelInput
            labelText="파트너 회사명"
            type="text"
            value={info?.salesPartnerCompanyName || '-'}
            inputStyle={{border: 0}}
            readOnly
            disabled
          />
          <LabelInput
            labelText="managerName"
            type="text"
            value={info?.name || '-'}
            setValue={(value: string) =>
              setInfo((prev: any) => ({...prev, name: value}))
            }
          />
          <LabelInput
            labelText="phone"
            type="text"
            value={formatPhoneNumber({phone: info?.phone || ''}) || '-'}
            disabled
            readOnly
            inputStyle={{border: 0}}
          />
          <LabelInput
            labelText="이메일"
            type="text"
            value={info?.email || '-'}
            setValue={(value: string) =>
              setInfo((prev: any) => ({...prev, email: value}))
            }
          />
          <LabelInput
            labelText="가입일"
            type="text"
            value={
              info?.createdAt
                ? moment(info?.createdAt)?.format('YYYY-MM-DD')
                : '-'
            }
            disabled
            readOnly
            inputStyle={{border: 0}}
          />
          <LabelInput
            labelText="상태"
            type="text"
            value={info?.deletedAt ? '삭제' : info?.isBlock ? '정지' : '등록'}
            disabled
            readOnly
            inputStyle={{border: 0}}
          />
        </Inner>
      </Container>

      {modal !== '' && (
        <CommonModal
          title={modalData[modal]?.title}
          detail={modalData[modal]?.detail}
          firstButtonText={modalData[modal]?.firstButtonText}
          firstButtonStyle={modalData[modal]?.firstButtonStyle}
          secondButtonText={modalData[modal]?.secondButtonText}
          secondButtonStyle={modalData[modal]?.secondButtonStyle}
          firstButtonClick={modalData[modal]?.firstButtonClick}
          secondButtonClick={modalData[modal]?.secondButtonClick}
          closeModal={() => setModal('')}
        />
      )}
    </ScreenLayout>
  );
}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  margin-bottom: ${minmax(50)};
`;

const Inner = styled.div<{$device?: string}>`
  width: 70%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${minmax(40)};
  padding-top: 0;
  gap: ${minmax(40)};

  ${(props: any) =>
    props.$device === 'mobile' &&
    css`
      width: 90%;
      min-width: auto;
    `}
`;
